module.exports = __webpack_public_path__ + "img/greenCross.b732dd56.png";